export default {"src":"/_next/static/media/QuoteLight.9d7ae5e6.svg","height":25,"width":32,"blurWidth":0,"blurHeight":0};